<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import Common from "./tools/common";

export default {
  name: "App",
  data() {
    return {
      zh_CN,
    };
  },
  mounted() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    //在页面加载时读取sessionStorage里的cookie
    if (sessionStorage.getItem("cookie")) {
      if (this.$router.history.current.path != "/login") {
        Common.readCookie(JSON.parse(sessionStorage.getItem("cookie")));
      } else {
        sessionStorage.clear();
      }
      sessionStorage.removeItem("cookie");
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      sessionStorage.setItem("cookie", JSON.stringify(document.cookie));
    });
  },
};
</script>

<style>
#app {
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, Arial !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f9ff;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue